<!-- 销售数据 -->
<template>
  <div class="salesData">
    <el-form :disabled="forbidden" :model="salesData" ref="salesData" label-width="80px">
      <el-row :gutter="24">
        <!-- 账户组 -->
        <!-- <el-col :span="6">
          <el-form-item :label="$t('cooperation.label.sellAccountGroup')" prop="saleAccountGroup">
            <el-select clearable v-model="salesData.saleAccountGroup">
              <el-option label="贸易往来类客户" value="0"></el-option>
              <el-option label="财务往来类客户" value="1"></el-option>
              <el-option label="集团内部业务部门客户" value="2"></el-option>
              <el-option label="一次性客户" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!--   @change="changeSubject" -->
        <el-col :span="12">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item
                :label="$t('cooperation.label.sellReconciliationSubject')"
                prop="saleReconciliationSubject"
              >
                <el-select
                  :clearable="true"
                  :filterable="true"
                  :placeholder="$t('cooperation.placeholder.procurementReconciliationSubject')"
                  v-model="salesData.saleReconciliationSubject"
                  @change="changeSubject"
                >
                  <el-option
                    v-for="item of subjectList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 描述 -->
            <el-col :span="12">
              <el-form-item class="isShowLabel" prop="saleReconciliationSubjectDesc">
                <el-input
                  clearable
                  disabled
                  v-model="salesData.saleReconciliationSubjectDesc"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <el-divider content-position="left">{{ $t('supplyChain.label.customer') }}</el-divider>
    <!-- 供应链主体客户 -->
    <div class="tableStyle">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="supplyCustomer"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="supplyCustomerData"
        :edit-rules="supplyCustomerRules"
        :valid-config="{ message: 'none' }"
        :toolbar="{}"
        :edit-config="forbidden ? {} : { trigger: 'click', mode: 'row' }"
        @cell-click="getActiveIndex"
      >
        <vxe-table-column type="checkbox" width="50"></vxe-table-column>
        <vxe-table-column
          width="180px"
          field="partnerZhName"
          :title="$t('supplyChain.label.fullName')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <SearchModal
              size="mini"
              width="800"
              className="customer-search"
              :ref="'searchModal' + rowIndex.toString()"
              :model="row.productName"
              :placeholder="$t('supplyChain.placeholder.select')"
              :propName="searchDialog.propName"
              :API="searchDialog.API"
              :query="searchDialog.query"
              :currentValue="row.partnerZhName"
              :page="true"
              :isMultiple="true"
              :searchColumns="searchDialog.searchColumns"
              :columnList="searchDialog.columnList"
              @setSearchModal="setSearchModal"
            ></SearchModal>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="partnerCode"
          :title="$t('supplyChain.label.partnerCode')"
        ></vxe-table-column>
        <vxe-table-column
          field="searchCode"
          :title="$t('supplyChain.label.searchCode')"
        ></vxe-table-column>
        <vxe-table-column
          field="creditCode"
          :title="$t('cooperation.label.creditCode')"
        ></vxe-table-column>
        <vxe-table-column
          field="legalPerson"
          :title="$t('cooperation.label.legalPerson')"
        ></vxe-table-column>
        <vxe-table-column
          field="registeredAssets"
          :title="$t('cooperation.label.registeredAssets')"
        ></vxe-table-column>
        <vxe-table-column
          field="invoiceAddress"
          :title="$t('cooperation.label.invoiceAddress')"
        ></vxe-table-column>
        <vxe-table-column
          field="invoicePhone"
          :title="$t('cooperation.label.invoicePhone')"
        ></vxe-table-column>
        <vxe-table-column
          field="invoiceBankName"
          :title="$t('cooperation.label.invoiceBankName')"
        ></vxe-table-column>
        <vxe-table-column
          field="invoiceBankAccount"
          :title="$t('cooperation.label.invoiceBankAccount')"
        ></vxe-table-column>
        <vxe-table-column
          field="taxType"
          :title="$t('cooperation.label.taxType')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <span>{{ taxTypeData[scope.row.taxType] }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="enterpriseType"
          :title="$t('cooperation.label.enterpriseType')"
          :edit-render="{ type: 'visible' }"
        >
          <template v-slot:edit="scope">
            <span>{{ enterpriseTypeData[scope.row.enterpriseType] }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="tradeCurrencyName" :title="$t('cooperation.label.tradeCurrency')">
        </vxe-table-column>
        <!-- 按钮 -->
        <template v-if="!forbidden" v-slot:buttons>
          <vxe-button @click="addRow" type="primary" icon="el-icon-plus" class="vxe-btn-primary">{{
            $t('cooperation.buttons.add')
          }}</vxe-button>
          <vxe-button
            @click="handleDelete"
            type="primary"
            icon="el-icon-delete"
            class="vxe-btn-delete"
            >{{ $t('cooperation.buttons.delete') }}</vxe-button
          >
        </template>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import API from '@/api/masterData/supplyChain';
  import { mapState } from 'vuex';
  import { supplyCustomerRules } from '../rules/tableRules';
  import SearchModal from '@/components/SearchModal';
  export default {
    name: 'salesData',
    components: { SearchModal },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    props: {
      forbidden: {
        type: Boolean,
        default: false,
      },
      salesTableData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        activeIndex: '', // 激活行索引
        salesData: {
          saleAccountGroup: '', // 账户组
          saleReconciliationSubject: '1122010101', // 对账科目,默认应收账款-非关联客户-一般往来
          saleReconciliationSubjectDesc: '1122010101', // 对账科目描述
        },
        supplyCustomerData: [],
        supplyCustomerRules: supplyCustomerRules,
        addRowObj: {
          partnerZhName: '', // 客户名称
          partnerCode: '', // 客户编码
          searchCode: '', // 搜索简码
          creditCode: '', // 统一社会信用代码
          legalPerson: '', // 法人
          registeredAssets: '', // 注册资本（万元）
          invoiceAddress: '', // 开票地址
          invoicePhone: '', // 开票电话
          invoiceBankName: '', // 开票银行名称
          invoiceBankAccount: '', // 开票银行账号
          taxType: '', // 发票类型
          enterpriseType: '', // 企业类型
          tradeCurrencyName: '', // 交易币种(name)
        },
        searchDialog: {
          API: API.LIST_PARTNEREXTEND_NO_FILTER,
          query: {
            partnerZhName: '',
            adminFlag: '',
            departmentCode: '',
            partnerType: 'HZHB01', // 只查找客户类型
            requestStatus: 'ZT03',
            distinctFlag: true,
          },
          propName: 'partnerZhName', // detailProductDisplayName || productChName
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'partnerType', label: this.$t('cooperation.label.partnerType') },
            { prop: 'partnerZhName', label: this.$t('cooperation.label.partnerZhName') },
            { prop: 'partnerCode', label: this.$t('cooperation.label.partnerCode') },
            { prop: 'identityNo', label: this.$t('cooperation.label.identityNo') },
            { prop: 'creditCode', label: this.$t('cooperation.label.creditCode') },
            { prop: 'requestByName', label: this.$t('cooperation.label.requestByName') },
            { prop: 'requestTime', label: this.$t('cooperation.label.requestTime') },
            // { prop: "requestStatusName", label: this.$t('cooperation.label.requestStatus') },
          ],
        },
        taxTypeData: {}, // 发票类型
        enterpriseTypeData: {}, // 企业类型
        subjectList: [], // 对账科目
      };
    },
    mounted() {
      this.getDictList();
      this.getSalesTableData();
      this.searchDialog.query.adminFlag = this.userInfo.adminFlag;
      // this.searchDialog.query.departmentCode = this.userInfo.departmentCode;
    },
    methods: {
      changeSubject(val) {
        let obj = {};
        obj = this.subjectList.find((item) => {
          return item['value'] === val; //筛选出匹配数据
        });
        this.salesData.saleReconciliationSubjectDesc = obj ? obj.value : '';
      },
      // 获取销售表格数据
      getSalesTableData() {
        if (this.salesTableData) {
          this.supplyCustomerData = this.salesTableData.list;
          this.salesData.saleAccountGroup = this.salesTableData.saleAccountGroup;
          this.salesData.saleReconciliationSubject = this.salesTableData.saleReconciliationSubject;
          this.salesData.saleReconciliationSubjectDesc =
            this.salesTableData.saleReconciliationSubjectDesc;
        }
      },
      addRow() {
        this.supplyCustomerData.push(JSON.parse(JSON.stringify(this.addRowObj)));
        this.$refs.supplyCustomer.setActiveRow(
          this.supplyCustomerData[this.supplyCustomerData.length - 1]
        );
      },
      // 确定选择 => 获取合作伙伴详情
      setSearchModal(model, row) {
        if (!row[0].id) return;
        const params = {
          id: row[0].id,
        };
        this.$axios.get(API.GET_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            Object.keys(this.addRowObj).forEach((item) => {
              this.supplyCustomerData[this.activeIndex][item] = res.data.data[item];
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 表格删除行
      handleDelete() {
        const selectedList = this.$refs.supplyCustomer.getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('outsidePrice.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.supplyCustomer.removeSelecteds().then(() => {
              this.supplyCustomerData = this.$refs.supplyCustomer.getTableData().fullData;
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      returnData() {
        this.salesData.customerList = [];
        this.supplyCustomerData.forEach((item) => {
          const obj = {
            partnerNo: item.partnerCode,
            dataType: '1',
          };
          this.salesData.customerList.push(obj);
        });
        return new Promise((resolve, reject) => {
          this.$refs.supplyCustomer.validate((valid) => {
            if (valid) {
              resolve(this.salesData);
            } else {
              reject('salesData');
              this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('supplyChain.message.perfectSalesData'),
              });
            }
          });
        });
      },
      //保存
      saveData() {
        this.salesData.customerList = [];
        this.supplyCustomerData.forEach((item) => {
          const obj = {
            partnerNo: item.partnerCode,
            dataType: '1',
          };
          this.salesData.customerList.push(obj);
        });
        return new Promise((resolve) => {
          resolve(this.salesData);
        });
      },
      // 获取当前激活行索引
      getActiveIndex(value) {
        this.activeIndex = value.rowIndex;
      },
      getDictList() {
        const tenantCode = this.userInfo.tenantCode;
        // const companyCode = this.userInfo.companyCode;
        // 发票类型
        this.$axios
          .post(API.DICT_LIST, { dictType: 'tax_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              res.data.data.forEach((item) => {
                this.taxTypeData[item.value] = item.label;
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 企业类型
        this.$axios
          .post(API.DICT_LIST, { dictType: 'enterprise_type', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              res.data.data.forEach((item) => {
                this.enterpriseTypeData[item.value] = item.label;
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        // 对账科目
        // this.$baseRequest.getAccountListByCompanyCode(companyCode).then(res=>{
        //   this.subjectList = res;
        // })
        //  // 对账科目
        this.$axios
          .post(API.DICT_LIST, { dictType: 'generalLedgerAccountSales', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.subjectList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
    },
  };
</script>

<style>
  .salesData .el-select {
    width: 100%;
  }
</style>
